import { Switch } from "@mui/material"
import { DesktopTimePickerProps, TimePicker, TimeValidationError } from "@mui/x-date-pickers"
import { formatMessage } from "i18n/CurrentLocale"
import { DaySchedule, WeekDay } from "types"
import { TimeVisualiser } from "./TimeVisualiser"
import { convertTimeToMomentTime } from "screens/modals/EditCompanyWorkingHoursModal"
import { useState } from "react"


const defaultTimePickerProps: DesktopTimePickerProps = {
    views: ['hours', 'minutes'],
    format: 'HH:mm',
    ampm: false,
    minutesStep: 1
}

type WeekDayTableRowProps = {
    weekday: WeekDay,
    daySchedule: DaySchedule,
    saving: boolean,
    onToggleWeekDay: Function,
    onChangeTime: Function
}

export type TimeRangeValidationError = {
    start: TimeValidationError | undefined,
    end: TimeValidationError | undefined
}


export const WeekDayTableRow = (props: WeekDayTableRowProps) => {

    const [timeRangeValidationError, setTimeRangeValidationError] = useState<TimeRangeValidationError>({ start: undefined, end: undefined });
    const { weekday, daySchedule, onToggleWeekDay, onChangeTime, saving } = props;
    const { start, end } = props.daySchedule[0] ?? {};


    return (
        <tr data-testid={`tr-${weekday}`}>
            <td><Switch checked={!!daySchedule[0]} onChange={(e) => onToggleWeekDay(weekday, e)} disabled={saving} /></td>
            <td>{formatMessage({ id: weekday })}</td>
            <td>
                <TimePicker
                    {...defaultTimePickerProps}
                    disabled={!start || saving}
                    value={convertTimeToMomentTime(start)}
                    onChange={(e) => onChangeTime(weekday, 'start', e)}
                    maxTime={convertTimeToMomentTime(end)!}
                    onError={(err) => setTimeRangeValidationError((prev) => ({ ...prev, start: err }))}
                    slotProps={{
                        textField: {
                            helperText: timeRangeValidationError.start ? formatMessage({ id: 'WH_TIME_VALIDATION_ERROR_START' }) : '',
                            size: 'small',
                            slotProps: { htmlInput: { 'data-testid': 'start-time-picker' } },
                            sx: {
                                '& .MuiFormHelperText-root': {
                                    fontFamily: 'sofia-pro',
                                    fontWeight: '400',
                                    fontSize: '14px',
                                    lineHeight: '1.2em',
                                }
                            }
                        }
                    }}
                />
            </td>
            <td>
                <TimePicker
                    {...defaultTimePickerProps}
                    disabled={!end || saving}
                    value={convertTimeToMomentTime(end)}
                    onChange={(e) => onChangeTime(weekday, 'end', e)}
                    minTime={convertTimeToMomentTime(start)!}
                    onError={(err) => setTimeRangeValidationError((prev) => ({ ...prev, end: err }))}
                    slotProps={{
                        textField: {
                            helperText: timeRangeValidationError.end ? formatMessage({ id: 'WH_TIME_VALIDATION_ERROR_END' }) : '',
                            size: 'small',
                            slotProps: { htmlInput: { 'data-testid': 'end-time-picker' } },
                            sx: {
                                '& .MuiFormHelperText-root': {
                                    fontFamily: 'sofia-pro',
                                    fontWeight: '400',
                                    fontSize: '14px',
                                    lineHeight: '1.3em',
                                }
                            }
                        }
                    }}

                />
            </td>
            <td>
                <TimeVisualiser startTime={start} endTime={end} timeRangeValidationError={timeRangeValidationError} />
            </td>
        </tr>
    )
}
